import { render } from "./gg-doctor-detail.vue?vue&type=template&id=4a398853&scoped=true"
import script from "./gg-doctor-detail.vue?vue&type=script&lang=js"
export * from "./gg-doctor-detail.vue?vue&type=script&lang=js"

import "./gg-doctor-detail.vue?vue&type=style&index=0&id=4a398853&lang=scss&scoped=true"

import exportComponent from "/builds/gitlab-runner/ci/auto-build/hospital-user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a398853"]])

export default __exports__